import style from './Login.module.scss';
import TelegramLogo from "../../assets/images/telegram.svg";
import {Text} from "../../ui-components/text.tsx";
import {Heading} from "../../ui-components/heading.tsx";
import {Field, FieldGroup, Label} from "../../ui-components/fieldset.tsx";
import {Input} from "../../ui-components/input.tsx";
import {DefaultBtn} from "../../custom-components/DefaultBtn.tsx";
import {CustomSwitcher} from "../../custom-components/CustomSwitcher.tsx";
import {ToastContainer} from "react-toastify";
import clsx from "clsx";
import useLogin from "../../hooks/login/useLogin.ts";


export default function Login() {
    const {
        t,
        onChangeRefCodeExist,
        refCodeState,
        isRefCodeExist,
        onChangeLogin,
        onChangeRefCodeValue,
        userName,
        errState,
        sendForm,openRefTerms
    } = useLogin()
    return (
        <div className={style.Wrapper}>
            <ToastContainer className={'ToastContainer'} containerId={'login_id'}/>
            <div className={`${style.Container} overflow-auto custom-scrollBar`}>
                <div className={"flex flex-col justify-center items-center px-[16px] relative h-full"}>
                    <Heading className={"text-[22px] text-white-500 font-sarabun pb-[60px] font-bold"}
                             color={"white"}>Tex.media</Heading>
                    <Text className={"text-2xl text-white-500 pb-[16px]"}>{t("pages.login.heading")}</Text>
                    <Text
                        className={"text-[14px] text-center text-white-500 opacity-60 leading-[20px] font-normal break-words"}>
                        {t("pages.login.desc")}
                    </Text>
                </div>
                <div
                    className={"w-full flex flex-col justify-center items-center bg-white px-[16px] pb-4 relative h-full"}>
                    <form className={"w-full h-auto top-[-55px] flex flex-col justify-between absolute px-4"}>
                        <div>
                            <section className={"flex flex-col gap-y-[10px] mb-[32px]"}>
                                <FieldGroup className={"flex flex-col w-full h-full gap-x-[8px]"}>
                                    <Field className={"mb-0"}>
                                        <Label
                                            className={"flex flex-row items-center text-white-500 text-[14px] leading-[20px] mb-2 !text-white"}>
                                            <TelegramLogo className={"pr-[6px] w-24px h-24px "}
                                                          style={{height: "24px", width: "24px"}}/>
                                            {t("pages.login.input.telegramLabel")}
                                        </Label>
                                        <Input name={'telegram'}
                                               value={userName}
                                               onChange={onChangeLogin}
                                               className={clsx(`[&>input]:!text-sm [&>input]:px-[12px] [&>input]:py-[8px] [&>input]:text-black [&>input]:border [&>input]:!bg-white [&>input]:border-[var(--border-color-block)]  !mt-0`, {
                                                   "[&>input]:border [&>input]:border-[var(--border-color-red)]": errState
                                               })}
                                               placeholder={'telegram'}
                                               autoFocus/>
                                    </Field>
                                    {errState ? <Text
                                            className={"text-[var(--color-warning)] text-[14px] text-left leading-[20px] !mt-2"}>
                                            {t("pages.login.input.errTelegram")}
                                        </Text> :
                                        <Text className={"text-secondary text-[14px] text-left leading-[20px] !mt-2"}>
                                            {t("pages.login.input.telegramDetail")}
                                        </Text>}
                                </FieldGroup>
                            </section>
                            <section className={"flex flex-col gap-y-[10px]"}>
                                <CustomSwitcher value={isRefCodeExist} onChangeAction={onChangeRefCodeExist}
                                                label={t("pages.login.refCodeTitle")} login/>
                                {
                                    isRefCodeExist
                                        ? <FieldGroup className={"flex flex-col w-full h-full gap-x-[8px]"}>
                                            <Field className={"mb-0"}>
                                                <Input name={'refCode'}
                                                       value={refCodeState}
                                                       onChange={onChangeRefCodeValue}
                                                       className={"[&>input]:!text-sm [&>input]:px-[12px] [&>input]:py-[8px] [&>input]:border [&>input]:border-[var(--border-color-block)] !mt-0"}
                                                       placeholder={'ytd56d;'}
                                                />
                                            </Field>
                                            <Text className={"text-secondary text-[14px] text-left leading-[20px] !mt-2"}>
                                                {t("pages.login.refDesc")}<br/>
                                                <span className={"text-[var(--text-accent)] cursor-pointer"}
                                                      onClick={openRefTerms}>{t("pages.login.refLink")}</span>
                                            </Text>
                                        </FieldGroup>
                                        : ''
                                }
                            </section>
                        </div>
                    </form>
                    <div className={"w-full mt-auto"}>
                        <DefaultBtn title={t("pages.login.btn")} onClick={sendForm}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

